var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14.53 14.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{stroke:#1c3152;stroke-miterlimit:10;stroke-width:2px;}.cls-5{font-size:5px;fill:#39af4f;font-family:Montserrat-SemiBold, Montserrat;font-weight:600;}.cls-6{clip-path:url(#clip-path-4);}.cls-7{fill:#a7b9c5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 14.53,
    height: 14.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.07,7.26A7.2,7.2,0,1,0,7.27.05,7.2,7.2,0,0,0,.07,7.26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.64,27.91V25h3.8V22.69h-3.8V21.13H20V18.81h-7.4v9.1Zm-4.55-9.1H8v9.1h3.07ZM2.75,28.12a7.7,7.7,0,0,0,2.09-.3A6.06,6.06,0,0,0,6.71,27V23.12H4.05v2.3a3.06,3.06,0,0,1-1.12.22A2.06,2.06,0,0,1,1.35,25a2.26,2.26,0,0,1-.59-1.65,2.27,2.27,0,0,1,.6-1.66A2.12,2.12,0,0,1,3,21.09a2.59,2.59,0,0,1,2,1l2-1.73a4.53,4.53,0,0,0-1.76-1.31,6.11,6.11,0,0,0-2.4-.45,5.79,5.79,0,0,0-2.66.61A4.46,4.46,0,0,0-1.68,20.9a4.62,4.62,0,0,0-.66,2.46,4.68,4.68,0,0,0,.66,2.47A4.61,4.61,0,0,0,.13,27.52a5.62,5.62,0,0,0,2.62.6"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.27,14.46a7.21,7.21,0,1,0-7.2-7.2A7.2,7.2,0,0,0,7.27,14.46Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(2.88 9.05)"
  }, "ON"), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -7.34,
    y: 13.6,
    width: 32.31,
    height: 19.52
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.eefa70dccecbf1a43a3129c2458c466c.svg";
export { ForwardRef as ReactComponent };